import React from "react";
import { Typography } from "@mui/material";

const DisplayDates = ({ dates }) => (
  <>
    {dates?.map((date, index) => (
      <span key={index}>
        {new Date(date).toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        })}
        {index < dates.length - 1 ? ", " : ""}
      </span>
    ))}
  </>
);

export default DisplayDates;
